// Web-only notificationHandler - no-op since we don't have FCM set up for web yet
// This file prevents the native Firebase import from being bundled on web

console.log('Web notification handler loaded (no-op)');

export default {};
